(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-review-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.ctm_review_slider', {
      slidesPerView: 4,
      loop: false,
      centeredSlides: false,
      spaceBetween: 40,
      pagination: {
        el: '.swiper-pagination',
        clickable: false,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        575: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
        414: {
          slidesPerView: 1.5,
          spaceBetween: 28,
        },
        0: {
          slidesPerView: 1.5,
          spaceBetween: 28,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-review"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".ctm_testimonial_swiper", {
    slidesPerView: 4.5,
    spaceBetween: 10,
    centeredSlides: false,
    loop: false,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      dragSize: 160 // adjust as needed or remove this line
    },
    breakpoints: {
      1280: {
        slidesPerView: 4.5,
        spaceBetween: 10
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      575: {
        slidesPerView: 2.2,
        spaceBetween: 10,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
      414: {
        slidesPerView: 1.5,
        spaceBetween: 8,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
      0: {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: true,
        centeredSlidesBounds: true,
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-double"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".accordion-header");

    // Open first accordion by default
    if (headers.length > 0) {
      const firstItem = headers[0].parentElement;
      firstItem.classList.add("active");
      const firstIcon = headers[0].querySelector(".accordion-icon");
      firstIcon.innerHTML = `
        <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1H15" stroke="#5A8B84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    }

    headers.forEach((header) => {
      header.addEventListener("click", function () {
        const currentItem = this.parentElement;
        const isActive = currentItem.classList.contains("active"); // check if already open

        // Close all
        headers.forEach((h) => {
          h.parentElement.classList.remove("active");
          h.querySelector(".accordion-icon").innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 8H15M8 1V15" stroke="#5A8B84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
        });

        // If it wasn’t active, open it (toggle)
        if (!isActive) {
          currentItem.classList.add("active");
          this.querySelector(".accordion-icon").innerHTML = `
            <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1H15" stroke="#5A8B84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
        }
      });
    });
  });



  } catch(e) { console.error(e); }
})();
})();
